import React, { useState, useEffect } from 'react'
import { useSelector } from 'react-redux'
import styled from 'styled-components'
import { Link } from 'react-router-dom'
import todolist from 'images/icon/camera-gray.png'
import todolistOn from 'images/icon/camera-black.png'
import feed from 'images/icon/feed-gray.png'
import feedOn from 'images/icon/feed-black.png'
import mypage from 'images/icon/peaple-gray.png'
import mypageOn from 'images/icon/peaple-black.png'
import search from 'images/icon/home-gray.png'
import searchOn from 'images/icon/home-black.png'
import shop from 'images/icon/shop-gray.png'
import shopOn from 'images/icon/shop-black.png'

import { useCookies } from 'react-cookie'
import { sendWebViewMsg } from 'utils/bridge'

import { NavListInner, NavIconInner, NavIcon } from './style'

export default function MainFooterBar({ onClickNavItem }) {
  // const userInfo = useSelector((state) => {
  //   return state.userInfo
  // })
  const [cookies, setCookie, removeCookie] = useCookies()
  let url = window.location.href.split('/').pop()

  const [motishopNotiExist, setMotishopNotiExist] = useState(false)

  useEffect(() => {
    !cookies['shop_remove_notification'] || cookies['shop_remove_notification'] !== 'true'
      ? setMotishopNotiExist(true)
      : setMotishopNotiExist(false)
  }, [cookies])

  const checkUrl = (urlParam) => {
    return window.location.href.includes(urlParam)
  }

  const handleRemoveNotiSign = (e) => {
    let dataLink = e.currentTarget.getAttribute('data-link')
    if (dataLink) {
      const cookieDomain =
        process.env.REACT_APP_ENV === 'dev'
          ? 'localhost'
          : // '192.168.20.121'
            '.motiners.com'
      const cookieMaxAge = process.env.REACT_APP_ENV === 'dev' ? 10 : 60 * 60 * 24
      setCookie(`${dataLink}_remove_notification`, true, {
        path: '/',
        maxAge: cookieMaxAge,
        domain: cookieDomain,
      })
      sendWebViewMsg({ action: 'REQ_COOKIE_FLUSH' })

      if (onClickNavItem) {
        onClickNavItem(dataLink)
      }
    }
  }

  function NavList({ navicon, text, url, color, name }) {
    let newNotiDom = []

    if (name === 'shop' && motishopNotiExist === true) {
      newNotiDom.push(<NewNotiDom key={`${name}-new-notification-dom`}></NewNotiDom>)
    }

    return (
      <Link to={url} onClick={handleRemoveNotiSign} data-link={name}>
        <li>
          <NavIconInner>
            <NavIcon>
              <img src={navicon} alt={name}></img>
            </NavIcon>
            <NavTxt color={color}>{text}</NavTxt>
            {newNotiDom}
          </NavIconInner>
        </li>
      </Link>
    )
  }

  return (
    <NavListInner>
      <NavList
        url={`/`}
        navicon={url === '' ? searchOn : search}
        color={url === '' ? '#121212' : '#B0B0B0'}
        text={'홈'}
        name={'home'}
      />
      <NavList
        url={'/motishop'}
        navicon={checkUrl('/motishop') ? shopOn : shop}
        color={checkUrl('/motishop') ? '#121212' : '#B0B0B0'}
        text={'상점'}
        name={'shop'}
      />
      <NavList
        url={'/task/list'}
        navicon={checkUrl('/task') ? todolistOn : todolist}
        color={checkUrl('/task') ? '#121212' : '#B0B0B0'}
        text={'인증'}
        name={'task'}
      />
      <NavList
        url={'/feed'}
        navicon={checkUrl('/feed') ? feedOn : feed}
        color={checkUrl('/feed') ? '#121212' : '#B0B0B0'}
        text={'피드'}
        name={'feed'}
      />
      <NavList
        url={'/mypage'}
        navicon={
          checkUrl('archive') || checkUrl('mypage') || checkUrl('MypageSetting') ? mypageOn : mypage
        }
        color={
          checkUrl('archive') || checkUrl('mypage') || checkUrl('MypageSetting')
            ? '#121212'
            : '#B0B0B0'
        }
        text={'마이'}
        name={'mypage'}
      />
    </NavListInner>
  )
}

const NavTxt = styled.span`
  font-size: calc(100vw * (12 / 375));
  font-weight: 600;
  line-height: 1.9;
  color: ${(prop) => prop.color};

  position: absolute;
  bottom: auto;
  left: 0;
  right: 0;
  display: flex;
  white-space: pre;
  margin: 0 auto;
  text-align: center;
  justify-content: center;
`
const NewNotiDom = styled.div`
  width: 6px;
  height: 6px;
  background-color: #e51c00;
  border-radius: 100%;
  position: absolute;
  top: 0;
  right: calc(100vw * (23.5 / 375));
`
